import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Upload, Radio, Spin, message, Image, Select } from "antd";
import { Button, Input, Row, Col } from "antd";
import { CloseOutlined, FormOutlined, UploadOutlined } from "@ant-design/icons";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { uploadFileCourseLMS } from "../../../pages/Admin-pages/CAAdminCoursePages/courseUtils";
import { useSelector } from "react-redux";

const LMSContentEdit = ({
  CreateSuccessfull,
  CreateFailed,
  id,
  onCancel,
  visible,
  data1,
  editData,
  LoadUser,
}) => {
  console.log(editData);
  const formRef = useRef();
  const userInfo = useSelector((state) => state.user);
  const [contentType, setContentType] = useState("MEDIA");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [containsScormImage, setContainsScormImage] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const cleanupScormIfUnsaved = async () => {
    if (
      contentType === "SCORM" &&
      fileList.length > 0 &&
      fileList[0].delete_url
    ) {
      try {
        await Axios.delete("/deletes3folder/", {
          data: { delete_url: fileList[0].delete_url },
          headers: { "X-CSRFToken": csrfToken },
          withCredentials: true,
        });
      } catch (error) {
        message.warning("SCORM file could not be deleted on cancel.");
      }
    }
  };

  const handleCancel = async () => {
    await cleanupScormIfUnsaved();
    formRef.current.resetFields();
    setFileList([]);
    setUploadedFiles([]);
    onCancel();
    setContainsScormImage("");
    setContentType("MEDIA");
  };
  const [fileLoading, setFileLoading] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");

  // eslint-disable-next-line no-unused-vars
  const handleCourseImageUpdate = async (file_name) => {
    if (!file_name) return;

    const finalValues = {
      name: data1?.name,
      organization: userInfo?.data?.organization?.id,
      image_url: file_name,
    };
    try {
      await Axios.put(`/courseedit/?id=${id}`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      LoadUser();
    } catch (err) {
      // CreateFailed();
    } finally {
      setContainsScormImage("");
    }
  };
  const onFinish = async (values) => {
    // setLoadingSubmit(true);
    const nonScormFiles = {
      status: true,
      course: id,
      attachment: uploadedFiles.map((file) => ({ file_name: file.file_name })),
    };
    const additionalValues = {
      status: true,
      course: id,
      attachment: uploadedFiles.map((file) => ({ file_name: file.name })),
      content_id: uploadedFiles.length > 0 ? uploadedFiles[0].content_id : null,
      course_thumbnail_image:
        uploadedFiles.length > 0
          ? uploadedFiles[0].course_thumbnail_image
          : null,
      course_thumbnail_image_s3_url:
        uploadedFiles.length > 0
          ? uploadedFiles[0].course_thumbnail_image_s3_url
          : null,
      delete_url: uploadedFiles.length > 0 ? uploadedFiles[0].delete_url : null,
    };
    //  const additionalValues2 = {
    //     status: true,
    //     course: id,
    //      attachment: uploadedFiles.map((file) => ({ file_name: file.name })),
    //   };
    const newValues =
      values.type === "MEDIA"
        ? { ...values, ...nonScormFiles }
        : values.type === "VIMEO"
        ? {
            ...values,
            status: true,
            course: id,
            attachment: [{ file_name: values.vimeoLink }],
            component: values.vimeoLink,
          }
        : { ...values, ...additionalValues };

    // const newValues2 = { ...values, ...additionalValues2 };
    console.log(newValues);
    // try {
    //   await Axios.post("/coursedetails/", newValues, {
    //     headers: {
    //       "X-CSRFToken": csrfToken,
    //     },
    //   });
    //   if (
    //     values.use_as_course_image === "yes" &&
    //     containsScormImage !== "" &&
    //     values.type !== "SCORM"
    //   ) {
    //     await handleCourseImageUpdate(uploadedFiles[0].course_thumbnail_image);
    //   } else {
    //     setContainsScormImage("");
    //   }
    //   formRef.current.resetFields();
    //   setFileList([]);
    //   setUploadedFiles([]);
    //   onCancel();
    //   setContentType("MEDIA");
    //   CreateSuccessfull("New LMS Content Created");
    // } catch (err) {
    //   CreateFailed("LMS Content Creation Failed", err);
    // } finally {
    //   setLoadingSubmit(false);
    // }
  };

  const handleUpload = async (file) => {
    setFileLoading(true);
    const payload = {
      course_id: id,
      name: file.name,
      mode: "E-Learning",
      file_type: file.type ? file.type.split("/").pop().toUpperCase() : "FILE",
      type: "coursedetails",
      filename: file.name,
      file,
    };
    const file_name = await uploadFileCourseLMS(payload, csrfToken);
    setUploadedFiles(() => [{ file_name: file_name }]);
    setFileLoading(false);
  };

  const handleChange = async (info) => {
    // ✅ handle remove inside handleChange
    if (info.file.status === "removed") {
      setFileList([]);
      setUploadedFiles([]);
      return;
    }

    const file = info.file.originFileObj || info.file;
    const imageUrl = URL.createObjectURL(file);

    // Always replace with a single file
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url: imageUrl,
      originFileObj: file,
    };

    setFileList([newFile]);

    await handleUpload(file);
  };

  const [loading, setLoading] = useState(false);
  const handleScormUpload = async (file) => {
    setLoading(true);

    // If a file already exists, delete it before uploading the new one
    if (fileList.length > 0 && fileList[0].delete_url) {
      try {
        await Axios.delete("/deletes3folder/", {
          data: { delete_url: fileList[0].delete_url }, // Use delete_url here
          headers: { "X-CSRFToken": csrfToken },
          withCredentials: true,
        });
      } catch (error) {
        // Optionally handle delete error, but continue with upload
        message.warning("Previous SCORM file could not be deleted.");
      }
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("course_id", id);

    try {
      const [uploadRes] = await Promise.all([
        Axios.post("/uploadscorm/", formData, {
          headers: {
            "X-CSRFToken": csrfToken,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }),
        Axios.get("/scormprogress/", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          withCredentials: true,
        }),
      ]);
      const fileData = {
        uid: file.uid,
        name: uploadRes?.data?.filename,
        status: "done",
        url: URL.createObjectURL(file),
        originFileObj: file,
        delete_url: uploadRes?.data?.delete_url,
        content_id: uploadRes?.data?.content_id,
        course_thumbnail_image: uploadRes?.data?.course_thumbnail_image,
        course_thumbnail_image_s3_url:
          uploadRes?.data?.course_thumbnail_image_s3_url,
        course_title: uploadRes?.data?.course_title,
        course_description: uploadRes?.data?.course_description,
        scorm_version: uploadRes?.data?.scorm_version,
      };
      setContainsScormImage(
        uploadRes?.data?.course_thumbnail_image_s3_url || ""
      );
      setFileList([fileData]);
      setUploadedFiles([fileData]);
    } catch (error) {
      CreateFailed("SCORM Upload Failed", error);
    } finally {
      setLoading(false);
    }
  };
  const handleScormDelete = async (file) => {
    console.log(file);
    try {
      await Axios.delete("/deletes3folder/", {
        data: { delete_url: file.delete_url }, // Use delete_url here
        headers: { "X-CSRFToken": csrfToken },
        withCredentials: true,
      });
      setFileList([]);
      setUploadedFiles([]);
      message.success("SCORM file deleted successfully.");
    } catch (error) {
      CreateFailed("Failed to delete SCORM file", error);
      setFileList([]);
      setUploadedFiles([]);
    }
  };
  useEffect(() => {
    const loadForm = () => {
      setContentType(editData?.type || "MEDIA");
      if (editData?.attachment && Array.isArray(editData.attachment)) {
        const mappedFiles = editData.attachment.map((file, idx) => ({
          uid: file.uid || `${idx}`,
          name: file.file_name || `file-${idx}`,
          status: "done",
          url: file.url,
          originFileObj: undefined,
          delete_url: editData?.delete_url,
          content_id: editData?.content_id,
          course_title: editData?.name,
          course_description: editData?.description,
        }));
        setFileList(mappedFiles);
        setUploadedFiles(mappedFiles);
        if (formRef.current && editData) {
          formRef.current.setFieldsValue({
            name: editData?.name,
            description: editData?.description,
            type: editData?.type || "MEDIA",
            vimeoLink: editData?.attachment?.[0]?.file_name || "",
          });
        }
      }
    };
    if (editData) {
      loadForm();
    }
  }, [editData]);
  useEffect(() => {
    const loadForm = () => {
      if (formRef.current && contentType === "SCORM") {
        formRef.current.setFieldsValue({
          name: fileList?.[0]?.course_title,
          description: fileList?.[0]?.course_description,
          scorm_version: fileList?.[0]?.scorm_version,
        });
      }
    };
    loadForm();
  }, [fileList, contentType]);
  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={<p className="modal-heading">EDIT LMS CONTENT</p>}
      centered
      width={750}
      style={{ zIndex: 1000 }}
    >
      <Form
        name="lms-content-form"
        onFinish={onFinish}
        layout="vertical"
        ref={formRef}
        initialValues={{
          purchased_at: dayjs(),
        }}
        labelCol={{ span: 25 }}
        wrapperCol={{ span: 80 }}
        style={{ width: "100%" }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={10} xl={10}>
                <Form.Item
                  label={<p className="my-form-lables">Content Name</p>}
                >
                  <Form.Item
                    name="name"
                    noStyle
                    rules={[{ required: true, message: "name is required" }]}
                  >
                    <Input.TextArea
                      placeholder="Enter Content Name"
                      name="name"
                      // className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={14} xl={14}>
                <Form.Item
                  label={<p className="my-form-lables">Description</p>}
                >
                  <Form.Item name="description">
                    <Input.TextArea
                      placeholder="Enter your description"
                      name="description"
                      // className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="antd-test-client">
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              {/* Content Type Dropdown */}
              <Col xs={24} sm={12} md={10} lg={10} xl={10}>
                <Form.Item
                  label={<p className="my-form-lables">Content Type</p>}
                  name="type"
                  rules={[{ required: true, message: "Type is required" }]}
                >
                  <Select
                    placeholder="Select content type"
                    onChange={(value) => {
                      setContentType(value);
                      setFileList([]); // reset file list when switching
                    }}
                  >
                    <Select.Option value="SCORM">SCORM File</Select.Option>
                    <Select.Option value="MEDIA">Media Files</Select.Option>
                    <Select.Option value="VIMEO">Vimeo Link</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              {/* File Upload / Vimeo Link */}
              <Col xs={24} sm={12} md={10} lg={14} xl={14}>
                <Form.Item
                  label={<p className="my-form-lables">File Upload</p>}
                >
                  <Spin spinning={loading}>
                    {contentType === "SCORM" && (
                      <>
                        <Upload
                          name="scorm"
                          listType="text"
                          beforeUpload={() => false}
                          onChange={async (info) => {
                            if (info.file.status !== "removed") {
                              const file = info.file.originFileObj || info.file;
                              const isZip =
                                file &&
                                (file.type === "application/zip" ||
                                  file.name.toLowerCase().endsWith(".zip"));
                              if (isZip) {
                                await handleScormUpload(file);
                              } else {
                                CreateFailed(
                                  "Only .zip files are allowed for SCORM."
                                );
                              }
                            }
                          }}
                          onRemove={handleScormDelete}
                          multiple={false}
                          accept=".zip"
                          fileList={fileList}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{ width: 315 }}
                            disabled={loading}
                          >
                            Upload SCORM (.zip)
                          </Button>
                        </Upload>
                        <div style={{ color: "#888", marginTop: 8 }}>
                          Only <b>.zip</b> files are allowed for SCORM.
                        </div>
                      </>
                    )}
                    {contentType === "VIMEO" && (
                      <>
                        <Form.Item
                          name="vimeoLink"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Please enter Vimeo link",
                            },
                            {
                              pattern:
                                /^(https?:\/\/)?(www\.)?(vimeo\.com\/\d+|player\.vimeo\.com\/video\/\d+)$/,
                              message: "Please enter a valid Vimeo link",
                            },
                          ]}
                        >
                          <Input placeholder="Enter Vimeo video link" />
                        </Form.Item>
                        <div style={{ color: "#888", marginTop: 8 }}>
                          Upload a valid <b>Vimeo link</b> (e.g.,
                          https://vimeo.com/123456789 or
                          https://player.vimeo.com/video/123456789).
                        </div>
                      </>
                    )}

                    {contentType === "MEDIA" && (
                      <Spin spinning={fileLoading}>
                        <Upload
                          name="media"
                          listType="text"
                          beforeUpload={() => false}
                          onChange={handleChange}
                          fileList={fileList}
                          accept="
        image/*,
        video/*,
        audio/*,
        .ppt,.pptx,
        .pdf,
        .doc,.docx
      "
                          maxCount={1} // ensures only one file at a time
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{ width: 315 }}
                          >
                            Click to Upload
                          </Button>
                        </Upload>
                        <div style={{ color: "#888", marginTop: 8 }}>
                          Allowed file types:{" "}
                          <b>Images, Videos, Audios, PPT, PDF, DOCX</b>.
                        </div>
                      </Spin>
                    )}
                  </Spin>
                </Form.Item>
              </Col>
            </Row>
          </div>
          {containsScormImage && (
            <div className="antd-test-client">
              <Row gutter={20} style={{ marginLeft: "2rem" }}>
                <>
                  <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                    <Image
                      preview
                      src={containsScormImage}
                      alt="SCORM Thumbnail"
                      style={{
                        width: "190px",
                        height: "auto",
                      }}
                    />
                  </Col>

                  <Col xs={24} sm={10} md={8} lg={10} xl={8}>
                    <>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Use as Course Image?</p>
                        }
                        name="use_as_course_image"
                        initialValue="yes"
                      >
                        <Radio.Group>
                          <Radio value="yes">Yes</Radio>
                          <Radio value="no">No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </>
                  </Col>
                  <Col xs={24} sm={4} md={4} lg={4} xl={4}>
                    <Form.Item
                      label={<p className="my-form-lables">Version</p>}
                      name="scorm_version"
                    >
                      <Input
                        placeholder="Scorm Version"
                        name="scorm_version"
                        className="my-form-input-antd-test"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </>
              </Row>
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined /> Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ background: "#f58029" }}
              className="save-update-btn"
              loading={loadingSubmit}
            >
              Update <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default LMSContentEdit;
